import { __module as n } from "./chunk767.js";
import { __require as z } from "./chunk648.js";
import { __require as C } from "./chunk656.js";
import { __require as H } from "./chunk662.js";
var S = n.exports, l;
function R() {
  return l ? n.exports : (l = 1, function(q, D) {
    (function(s, r, f) {
      q.exports = r(z(), C(), H());
    })(S, function(s) {
      return function() {
        var r = s, f = r.lib, p = f.Base, h = f.WordArray, u = r.algo, y = u.SHA256, B = u.HMAC, k = u.PBKDF2 = p.extend({
          /**
           * Configuration options.
           *
           * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
           * @property {Hasher} hasher The hasher to use. Default: SHA256
           * @property {number} iterations The number of iterations to perform. Default: 250000
           */
          cfg: p.extend({
            keySize: 128 / 32,
            hasher: y,
            iterations: 25e4
          }),
          /**
           * Initializes a newly created key derivation function.
           *
           * @param {Object} cfg (Optional) The configuration options to use for the derivation.
           *
           * @example
           *
           *     var kdf = CryptoJS.algo.PBKDF2.create();
           *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8 });
           *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8, iterations: 1000 });
           */
          init: function(e) {
            this.cfg = this.cfg.extend(e);
          },
          /**
           * Computes the Password-Based Key Derivation Function 2.
           *
           * @param {WordArray|string} password The password.
           * @param {WordArray|string} salt A salt.
           *
           * @return {WordArray} The derived key.
           *
           * @example
           *
           *     var key = kdf.compute(password, salt);
           */
          compute: function(e, v) {
            for (var a = this.cfg, t = B.create(a.hasher, e), i = h.create(), x = h.create([1]), A = i.words, K = x.words, _ = a.keySize, P = a.iterations; A.length < _; ) {
              var c = t.update(v).finalize(x);
              t.reset();
              for (var m = c.words, b = m.length, d = c, g = 1; g < P; g++) {
                d = t.finalize(d), t.reset();
                for (var w = d.words, o = 0; o < b; o++)
                  m[o] ^= w[o];
              }
              i.concat(c), K[0]++;
            }
            return i.sigBytes = _ * 4, i;
          }
        });
        r.PBKDF2 = function(e, v, a) {
          return k.create(a).compute(e, v);
        };
      }(), s.PBKDF2;
    });
  }(n), n.exports);
}
export {
  R as __require
};
